import React from 'react';

const testimonials = [
  {
    name: "Lits83",
    text: "Building a home can be hard but BuildPilot makes the whole process easy. Your personal building concierge at your fingertips. Highly recommend.",
    rating: 5,
    color: "from-blue-500 to-cyan-400"
  },
  {
    name: "Tim Finance 75",
    text: "I've recommended the BuildPilot App to our customers, and they've found tremendous value in it. The app effectively simplifies the complex process of building.",
    rating: 5,
    color: "from-emerald-500 to-teal-400"
  },
  {
    name: "DanGauci",
    text: "My wife and I have been thinking of building for years and this app helps us understand the building process. Well done team!",
    rating: 5,
    color: "from-violet-500 to-purple-400"
  },
  {
    name: "Pierre.Boutros",
    text: "BuildPilot is an excellent app for anyone who wants to streamline the building process. It combines ease of use with powerful tools.",
    rating: 5,
    color: "from-amber-500 to-orange-400"
  },
  {
    name: "Savmagnum",
    text: "An absolute must have tool if looking to build a new home. Smart design of the app makes everything easy to find and use.",
    rating: 5,
    color: "from-rose-500 to-pink-400"
  },
  {
    name: "George Gian",
    text: "Lots of tools that are relevant to the process of building a home. The cost tracker is one of our favourite tools.",
    rating: 5,
    color: "from-indigo-500 to-blue-400"
  },
  {
    name: "NickGWW",
    text: "Such a great app for anyone that is currently building! Easy to use and has everything you need. Definitely recommend!",
    rating: 5,
    color: "from-teal-500 to-green-400"
  },
  {
    name: "Helgztry2348",
    text: "This app has been so helpful during our building process. Thank you BuildPilot!",
    rating: 5,
    color: "from-fuchsia-500 to-pink-400"
  }
];

const ReviewCard = ({ review }) => (
  <div 
    className="flex-shrink-0 w-[300px] sm:w-[340px] p-5 sm:p-6 rounded-2xl border border-gray-200/60 bg-white/80 backdrop-blur-sm"
    data-testid={`review-card-${review.name.toLowerCase().replace(/\s+/g, '-')}`}
  >
    {/* Review Text */}
    <p className="text-gray-700 text-sm sm:text-base leading-relaxed mb-5">
      {review.text}
    </p>
    
    {/* Author Info */}
    <div className="flex items-center gap-3">
      {/* Avatar */}
      <div className={`w-10 h-10 bg-gradient-to-br ${review.color} rounded-full flex items-center justify-center text-white text-sm font-semibold flex-shrink-0`}>
        {review.name.charAt(0).toUpperCase()}
      </div>
      
      <div className="flex-1 min-w-0">
        <h4 className="font-semibold text-gray-900 text-sm">{review.name}</h4>
        {/* Source Badge */}
        <div className="flex items-center gap-1.5">
          <svg className="w-3.5 h-3.5 text-gray-400" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.09997 22C7.78997 22.05 6.79997 20.68 5.95997 19.47C4.24997 17 2.93997 12.45 4.69997 9.39C5.56997 7.87 7.12997 6.91 8.81997 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z"/>
          </svg>
          <span className="text-xs text-gray-400">App Store</span>
        </div>
      </div>
      
      {/* Star Rating */}
      <div className="flex gap-0.5">
        {[...Array(review.rating)].map((_, i) => (
          <svg key={i} className="w-4 h-4 text-amber-400" fill="currentColor" viewBox="0 0 20 20">
            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/>
          </svg>
        ))}
      </div>
    </div>
  </div>
);

const TestimonialsSection = () => {
  // Split testimonials for two rows
  const row1 = [...testimonials.slice(0, 4), ...testimonials.slice(0, 4)];
  const row2 = [...testimonials.slice(4), ...testimonials.slice(4)];

  return (
    <section className="py-16 sm:py-20 bg-white overflow-hidden" id="testimonials" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-10 sm:mb-12">
        <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl text-gray-900 text-center">
          See What Our <span className="gradient-text">Users Are Saying</span>
        </h2>
      </div>
      
      {/* Scrolling Container */}
      <div className="relative space-y-5">
        {/* Gradient Fades */}
        <div className="absolute left-0 top-0 bottom-0 w-16 sm:w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-16 sm:w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />
        
        {/* Row 1 - Scrolls Left */}
        <div className="flex gap-5 marquee-row-1" data-testid="testimonials-row-1">
          {row1.map((review, index) => (
            <ReviewCard key={`row1-${review.name}-${index}`} review={review} />
          ))}
        </div>
        
        {/* Row 2 - Scrolls Right */}
        <div className="flex gap-5 marquee-row-2" data-testid="testimonials-row-2">
          {row2.map((review, index) => (
            <ReviewCard key={`row2-${review.name}-${index}`} review={review} />
          ))}
        </div>
      </div>
      
      {/* Custom CSS for animation */}
      <style>{`
        @keyframes marquee-left {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        
        @keyframes marquee-right {
          0% {
            transform: translateX(-50%);
          }
          100% {
            transform: translateX(0);
          }
        }
        
        .marquee-row-1 {
          animation: marquee-left 35s linear infinite;
        }
        
        .marquee-row-2 {
          animation: marquee-right 40s linear infinite;
        }
        
        .marquee-row-1:hover,
        .marquee-row-2:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
};

export default TestimonialsSection;
